export const LANG_PROPER_NAME = "proper";

export const LANG_PROPER_TRANS = {
	"application.title" : "SafeConnect",
	"company.name" : "Impulse Point, LLC.",
	"download.media.md5" : "MD5",
}
